<ng-container *ngIf="hasPasswordRequirements()">
    <mat-password-strength
        #passwordStrengthComponent
        [warnThreshold]="100"
        [enableLengthRule]="passwordStrengthConfig.lengthRule"
        [enableDigitRule]="passwordStrengthConfig.digitRule"
        [enableLowerCaseLetterRule]="passwordStrengthConfig.lowerCaseRule"
        [enableUpperCaseLetterRule]="passwordStrengthConfig.upperCaseRule"
        [enableSpecialCharRule]="passwordStrengthConfig.specialCharRule"
        [customValidator]="passwordStrengthConfig.customRegex"
        (onStrengthChanged)="onStrengthChanged($event)"
        [password]="password"></mat-password-strength>
    <mat-password-strength-info
        [passwordComponent]="passwordStrengthComponent"
        customCharsCriteriaMsg="{{
            passwordStrengthConfig.customRegexMessage
        }}"></mat-password-strength-info>
</ng-container>
